<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom noArrow>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image">
                <transition name="fade" mode="out-in" appear>
                  <vueVimeoPlayer
                    height="100%"
                    width="100%"
                    ref="player"
                    class="intro-video"
                    :controls=false                            
                    :options="{
                      autoplay:true,
                      muted:true
                    }"        
                    video-id="734466140"  
                    :style="videoStyle"
                  />
                </transition>
              </div>              
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>
//542701148 original
//734466140 video 3
import PageBottom from "@/patterns/PageBottom.vue";
//import TitleContent from "@/patterns/TitleContent.vue";
//import Feature from "@/patterns/Feature.vue";
import { vueVimeoPlayer } from "vue-vimeo-player";
export default {
  name: "SeamlessLoad",
  components: { PageBottom, vueVimeoPlayer },
  data: () => ({
    scrollContent: false,
    videoStyle: {}    
  }),  
  mounted() {    
    this.adjustVideo();
    window.addEventListener("resize", this.shouldScrollContent);
    window.addEventListener("resize", this.adjustVideo);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
    window.removeEventListener("resize", this.adjustVideo);
  }, 
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
    adjustVideo() {
      let height = Math.max(480, window.innerHeight);
      let width = Math.max(800, window.innerWidth);
      let vw, vh;
      if (width / height > 16 / 9) {
        vw = Math.round(width);
        vh = Math.round((vw * 9) / 16);
      } else {
        vh = Math.round(height);
        vw = Math.round((vh * 16) / 9);
      }
      this.videoStyle = {
        width: vw + "px",
        height: vh + "px",
        left: (width - vw) / 2 + "px",
        right: (height - vh) / 2 + "px",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.large {
  display:inline-block;
  max-width: 40vw;
  margin-right:25px;
  margin-top:0;
}
</style>
